import React from 'react';
import { PlayerManager } from '../components/Queue';
import { PlayerStats } from '../components/Statistics';

const PlayersPage: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h1 className="text-2xl font-bold text-gray-900">人员管理</h1>
        <p className="text-gray-600 mt-1">管理参赛人员和查看个人统计</p>
      </div>

      {/* Content */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <PlayerManager />
        <PlayerStats />
      </div>
    </div>
  );
};

export default PlayersPage;